import React, { Component } from 'react';
import Button from 'material-ui/Button';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog';
import withWidth from 'material-ui/utils/withWidth';
import compose from 'recompose/compose';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import AuthService from '../AuthService';

const styles = {
  fullScreenTitleWrapper: {
    textAlign: 'center',
    marginTop: 5 + '%'
  },
  fullScreenTitle: {
    // 3rem pushes the letters too close together
    fontSize: 2.9 + 'rem'
  },
  fullScreenContent: {
    textAlign: 'center',
    fontSize: 2 + 'rem',
    marginBottom: 2 + '%',
    marginTop: 2 + '%'
  },
  fullScreenActions: {
    marginBottom: 2 + '%'
  },
  fullScreenButtons: {
    fontSize: 2 + 'rem'
  }
};

class InPersonDialog extends Component {
  constructor(props) {
    super(props);
    this.Auth = new AuthService();
    this.onStartSigning = this.onStartSigning.bind(this);
  }

  parseUrl(url) {
    const l = document.createElement('a');
    l.href = url;
    return l;
  }

  onStartSigning() {
    const inPersonUrl = window.location;
    let signingUrl = this.props.participant.signingUrl;
    if (process.env.REACT_APP_SIGNING_URL) {
      const parser = this.parseUrl(signingUrl);
      signingUrl = `${process.env.REACT_APP_SIGNING_URL}${parser.pathname}${
        parser.search
      }${parser.hash}`;
    }
    signingUrl += `&inPersonUrl=${encodeURI(inPersonUrl)}`;
    console.log('InPersonDialog : signingUrl', signingUrl);
    window.location = `${signingUrl}`;
  }

  render() {
    const { classes } = this.props;
    const hostName = this.Auth.getUser().name;
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          participant={this.props.document.nextParticipant}
          document={this.props.document}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen={true}
        >
          <DialogTitle
            id="alert-dialog-title"
            className={classes.fullScreenTitleWrapper}
          >
            <span className={classes.fullScreenTitle}>
              {this.props.showHostContent && 'Start Hosting'}
              {this.props.showSigningContent && 'Sign Document'}
              {this.props.showCancelContent && 'Cancelled'}
            </span>
          </DialogTitle>

          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              className={classes.fullScreenContent}
            >
              {this.props.showHostContent &&
                'Please verify ' +
                  this.props.participant.name +
                  ' is ready to sign ' +
                  this.props.document.name +
                  ' in person. Once verified, please give the device to ' +
                  this.props.participant.name +
                  '.'}

              {this.props.showSigningContent &&
                'Please confirm that you, ' +
                  this.props.participant.name +
                  ', are ready to sign ' +
                  this.props.document.name +
                  ' in person.'}

              {this.props.showCancelContent &&
                'Signing has been cancelled. Please give the device back to ' +
                  hostName +
                  '.'}
            </DialogContentText>
          </DialogContent>

          <DialogActions className={classes.fullScreenActions}>
            <Grid container spacing={24} justify="center">
              {(this.props.showHostContent ||
                this.props.showSigningContent) && (
                <Grid item xs={12} sm={6}>
                  <Button
                    onClick={
                      this.props.showHostContent
                        ? this.props.onClose
                        : this.props.onActivateCancelContent
                    }
                    color="secondary"
                    className={classes.fullScreenButtons}
                    variant="raised"
                    size="large"
                    fullWidth={true}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}
              {(this.props.showHostContent ||
                this.props.showSigningContent) && (
                <Grid item xs={12} sm={6}>
                  <Button
                    onClick={
                      this.props.showHostContent
                        ? this.props.onStartHosting
                        : this.onStartSigning
                    }
                    color="primary"
                    autoFocus
                    className={classes.fullScreenButtons}
                    variant="raised"
                    size="large"
                    fullWidth={true}
                  >
                    <span>
                      {this.props.showHostContent ? 'Verify' : 'Confirm'}
                    </span>
                  </Button>
                </Grid>
              )}
              {this.props.showCancelContent && (
                <Grid item xs={12} sm={6}>
                  <Button
                    onClick={this.props.onClose}
                    color="secondary"
                    autoFocus
                    className={classes.fullScreenButtons}
                    variant="raised"
                    size="large"
                    fullWidth={true}
                  >
                    {hostName + ' Clicks Here'}
                  </Button>
                </Grid>
              )}
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default compose(withWidth(), withStyles(styles))(InPersonDialog);



// WEBPACK FOOTER //
// ./src/components/InPersonDialog.js